import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { Meses, obtenerError, obtenerTamMax, Responsables } from '../../../models/Formulacion/indicadores-metas/datos';
import { FiltersM } from '../../../components/models';
import { ActasService } from '../../../services/seguimiento/actas/actas.service';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { messages } from '../../funciones/mensajes';
import { ExcelService } from '../../../services/excel/excel.service';
import Swal from 'sweetalert2';
import { MatMenuTrigger } from '@angular/material/menu';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { ResponsableService } from '../../../services/gestion/responsable/responsable.service';
import { PlanesService } from '../../../services/gestion/planes/planes.service';
import { PERMISOS } from '../../../shared/catalogos';
import { truncate } from 'fs';

@Component({
  selector: 'app-actas',
  templateUrl: './actas.component.html',
  styleUrl: './actas.component.css'
})
export class ActasComponent implements OnInit {
  public readonly permisos = PERMISOS;

  /* Variables de plan */
  private idPlaneacion = 0;

  /* Variables de edición en tabla */
  private edicion: boolean;
  private semaforo: any = [];
  /* Variables de funcionamiento de tablas */
  public mostabla = false;
  public skeleton = new Array(15);
  public skeletonColums = new Array(6);
  public mostrarAllActas = true;
  public adicionales = [];
  public ordenamiento = 'id';
  private fechaAct = moment();
  /* Variables de las tabla */
  private actas = [];
  public actasMostrar = [];
  public actividadesActas = [];
  /* Variables de filtros */
  public Filters = FiltersM;
  public aniosDisponibles = [];
  public diasLab;
  public Periodo = '';
  public responsables: Responsables[] = [];
  public responsablesActas: Responsables[] = [];
  public responsablesActividadesActas: Responsables[] = [];
  public selecAllResActas = true;
  public selecAllResActiv = true;
  /* Variables para el formateo de cantidades */
  public separador: string = ","; // separador para los miles
  public sepDecimal: string = '.'; // separador para los decimales
  /** Lectura de archivos */
  selectedFiles: FileList;
  //Es el array que contiene los items para mostrar el progreso de subida de cada archivo
  progressInfo = [];
  message = '';
  imageName = "";
  /** click izquierdo */
  @ViewChild(MatMenuTrigger, { static: true }) matMenuTrigger: MatMenuTrigger;
  menuTopLeftPosition = { x: '0', y: '0' };
  private adDelete: any;
  private adActivi: any;

  constructor(
    public dataService: DataService,
    private actasService: ActasService,
    private cookies: CookieService,
    private excelService: ExcelService,
    private translate: TranslateService,

    private readonly planificacionService: PlanificacionService,
    private readonly responsableService: ResponsableService,
    private readonly actaService: PlanesService,
  ) {
    this.obtenerDatos();
  }

  ngOnInit(): void {
  }

  /* Consultas para obtención de información */
  private async obtenerDatos() {
    this.idPlaneacion = Number(this.cookies.get('idInstitucion'));
    try {
      this.idPlaneacion = Number(this.cookies.get('idInstitucion'));
      const plan = await this.planificacionService.getPlanificacionByIdGQL(this.idPlaneacion);
      await this.obtenerFiltros(plan);
      const res2 = await this.actaService.getActasGql(`${this.idPlaneacion}`);
      this.obtenerActas(res2);

    } catch (error) {
    }
  }
  /* Extracción de datos */
  // Filtros
  private seleccionarPeriodo(){
    this.aniosDisponibles.forEach(a => {
      a.series.forEach(m => m.check = false);
    });
    const ultimoAnio = this.aniosDisponibles[this.aniosDisponibles.length - 1];
    const ultimoPeriodo = ultimoAnio.series[ultimoAnio.series.length - 1];

    const periodoActual = moment().format('MMM-YY').toLowerCase();

    if (ultimoPeriodo.periodo === periodoActual) {
      const series = ultimoAnio.series;
      const indice = series.length - 1;

      if (indice > 0) {
        series[indice - 1].check = true;
        this.Periodo = series[indice - 1].periodo;
      }
    } else {
      ultimoPeriodo.check = true;
      this.Periodo = ultimoPeriodo.periodo;
    }
  }
  private async obtenerFiltros(planeacion: any){
    this.edicion = planeacion.isActive;
    const sema = this.ordenamientoSem(planeacion.signals);
    if( Number(sema[sema.length-1].value_01) > 100){
      const valFinal = Number(sema[sema.length-1].value_01); 
      for(const sem of sema){
        this.semaforo.push({
          valIn: Math.round((Number(sem.value_00)*100)/valFinal) === 0? Math.round((Number(sem.value_00)*100)/valFinal):Math.round((Number(sem.value_00)*100)/valFinal)+0.1,
          valfin: Math.round((Number(sem.value_01)*100)/valFinal),
          color: sem.color[0],
        });
      }      
    }else{
      for(const sem of sema){
        this.semaforo.push({
          valIn: Number(sem.value_00),
          valfin: Number(sem.value_01),
          color: sem.color[0],
        });
      }
    }

    this.diasLab = planeacion.business_days;
    this.aniosDisponibles = Meses.obtenerPeriodos(moment(planeacion.initial_date).toDate(), moment(planeacion.end_date).toDate());
    this.seleccionarPeriodo();

    try{
      const res = await lastValueFrom(this.responsableService.getResponsable());
      this.responsables = [];
        var aux = [];
        for(const are of res){
          if(are.institution.id === planeacion.institution.id){
            for(const res of are.responsibles){
              aux.push({
                nombre: res.position,
                id: res.id,
                check: true,
                isValidator: res.isValidator,
              });
            }
          }
        }
        this.responsables = this.ordenamientoAlf(aux);
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  // Actas
  private obtenerActas(array: any){
    var auxiliar = [];
    for(const acta of array){
      var aux = [];
      for(const acti of acta.activities){
        var hist = [];
        var historicosCom = Meses.obtenerPlaneado(new Date(acti.initial_date), new Date(acti.end_date), this.diasLab);
        let hisAg = 0;
        for(const his of historicosCom){
          const ex = acti.history.filter(h => h.period === his.periodo);
          if(ex.length !== 0){
            hist.push({
              periodo: ex[0].period,
              planeado: Number(ex[0].planned),
              ejecutado: ex[0].executed,
              id: ex[0].id,
            });
            hisAg++;
          }else{
            hist.push({
              periodo: his.periodo,
              planeado: Number(his.planeado),
              ejecutado: his.ejecutado,
              id: his.id,
            });
          }
        }
        if(hisAg !== acti.history.length){
          for(const h of acti.history){
            const ex = hist.filter(hi => hi.periodo === h.period);
            if(ex.length === 0){
              hist.push({
                periodo: h.period,
                planeado: Number(h.planned),
                ejecutado: h.executed,
                id: h.id,
              });
            }
          }
        }
        hist = this.ordenamientoHis(hist);
        const final = hist.find(h => h.planeado === 100);
        var completed = false;
        if(final.planeado === final.ejecutado){
          completed = true;
        }else{
          completed = acti.completed;
        }
        aux.push({
          nombre: acti.name,
          fecha_inicio: moment(acti.initial_date.split('T')[0]),
          fecha_fin: moment(acti.end_date.split('T')[0]),
          projectId: acta.id,
          responsable: acti.responsible,
          validacion: acti.validated,
          completada: completed,
          id: acti.id,
          adicionales: this.ordenamientoAdi(acti.additions),
          history: hist,
        });
      }
      auxiliar.push({
        nombre: acta.name,
        descripcion: acta.description,
        responsable: acta.validator,
        acta: acta.attachment,
        id: acta.id,
        check: true,
        fecha_ini: undefined,
        fecha_fin: undefined,
        actividades: aux,
      });
    }
    this.actas = auxiliar;
    this.actas = this.ordenamientoPer(this.actas);

    try{
      this.obtenerfechasActas();
      this.adicionales = this.actas[0].actividades[0]?.adicionales.length > 0? this.actas[0].actividades[0]?.adicionales.map( r => { return {...r}}): [];
      this.dataTablaMostrar('cam');
      this.obtResponsableDinamico();
    }catch(err){
      err
    }
    this.mostabla = true;
  }
  // private obtenerActas(array: any) {
  //   var auxiliar = [];
  //   for (const acta of array) {
  //     //var resExiste = this.responsables.filter(res => res.id === acta.validator.id);
  //     if (Number(acta.plan.id) === this.idPlaneacion) {//resExiste.length !== 0 && 
  //       auxiliar.push({
  //         nombre: acta.name,
  //         descripcion: acta.description,
  //         responsable: acta.validator,
  //         acta: acta.attachment,
  //         id: acta.id,
  //         check: false,
  //         fecha_ini: undefined,
  //         fecha_fin: undefined,
  //         actividades: [],
  //       });
  //     }
  //   }
  //   this.actas = auxiliar;
  //   this.actas = this.ordenamientoPer(this.actas);
  // }
  // Actividades de las actas
  private async obtenerActividadesActas(array) {
    if (this.actas.length !== 0) {
      for (const actas of this.actas) {
        const actividades = array.filter(actaId => actaId.minute.id === actas.id);
        if (actividades.length !== 0) {
          var auxiliar = [];
          for (const acti of actividades) {
            var hist = [];
            if (acti.history.length === 0) {
              hist = Meses.obtenerPlaneado(moment(acti.initial_date).toDate(), moment(acti.end_date).toDate(), this.diasLab);

              // Procesar historiales de forma secuencial
              for (const his of hist) {
                try {
                  const response = await firstValueFrom(this.actasService.postHistorico(his, Number(acti.id)));
                  his.id = response.id;
                } catch (err) {
                  let er = obtenerError.errorObt(err['error'].message);
                  messages.errorMessageGraph(er);
                }
              }
            } else {
              for (const his of acti.history) {
                hist.push({
                  periodo: his.period,
                  planeado: Number(his.planned),
                  ejecutado: his.executed,
                  id: his.id,
                });
              }
            }

            auxiliar.push({
              nombre: acti.name,
              fecha_inicio: moment(acti.initial_date).toDate(),
              fecha_fin: moment(acti.end_date).toDate(),
              projectId: acti.minute.id,
              responsable: acti.responsible,
              validacion: acti.validated,
              completada: acti.completed,
              id: acti.id,
              adicionales: [],
              history: hist,
            });
          }
          actas.actividades = auxiliar;
        }
      }
    }
  }
  //Adicionales de las actividades
  private obtenerAdicionalesActividades(array) {
    if (this.actas.length !== 0) {
      for (const acta of this.actas) {
        if (acta.actividades.length !== 0) {
          for (const act of acta.actividades) {
            var adicional = array.filter(adi => adi.activity !== null && adi.activity.id === act.id);
            adicional = this.ordenamientoAdi(adicional);
            act.adicionales = adicional;
          }
        }
      }
      this.obtenerfechasActas();
      this.adicionales = this.actas[0].actividades[0].adicionales;
      this.dataTablaMostrar('cam');
      this.obtResponsableDinamico();
    }
  }
  /** Obtención de los datos */
  //Fechas de proyectos
  public obtenerfechasActas() {
    for (const pro of this.actas) {
      for (const act of pro.actividades) {
        if (pro.fecha_ini === undefined) {
          pro.fecha_ini = act.fecha_inicio;
        } else {
          if (moment(pro.fecha_ini).isAfter(moment(act.fecha_inicio))) {
            pro.fecha_ini = act.fecha_inicio;
          }
        }
        if (pro.fecha_fin === undefined) {
          pro.fecha_fin = act.fecha_fin;
        } else {
          if (moment(pro.fecha_fin).isBefore(moment(act.fecha_fin))) {
            pro.fecha_fin = act.fecha_fin;
          }
        }
      }
    }
  }
  //Obtención de fechas
  public obtFecha(fec: any) {
    if (fec != undefined) {
      return moment(fec).format('DD-MM-YYYY');
    }
    return '';
  }
  /* Obtención de datos a mostrar */
  public dataTablaMostrar(parametros: any) {
    var actasTot = [].concat(this.actas);
    this.actasMostrar = [];
    for (const acta of actasTot) {
      switch (parametros) {
        case 'all':
          if (this.mostrarConResponsables(acta)) {
            this.actasMostrar.push({
              nombre: acta.nombre,
              descripcion: acta.descripcion,
              responsable: acta.responsable,
              acta: acta.acta,
              id: acta.id,
              check: acta.check,
              fecha_ini: acta.fecha_ini,
              fecha_fin: acta.fecha_fin,
              actividades: acta.actividades,
            });
          }
          break;
        case 'cam':
          if (this.mostrar(acta)) {
            this.actasMostrar.push(acta);
          }
          break;
      }
    }
    if (parametros === 'all' && !this.selecAllResActiv) {
      const res = this.responsablesActividadesActas.filter(res => res.check === true);
      if (res.length !== 0) {
        for (const a of this.actasMostrar) {
          const act = a.actividades.filter(act => this.responsableActOfActas(act) === true);
          a.actividades = act;
        }
      }
    }
  }
  //Obtención de responsables
  private obtResponsableDinamico() {
    var aux = [], aux2 = [];
    for (const acta of this.actasMostrar) {
      const res = this.responsables.filter(res => res.id === acta.responsable.id);
      const existe = aux.filter(res => res.id === acta.responsable.id);
      if (existe.length === 0) {
        aux.push({
          nombre: res[0].nombre,
          name: res[0].nombre,
          id: res[0].id,
          check: true,
        });
      }
      for (const resp of acta.actividades) {
        const resAct = this.responsables.filter(res => res.id === resp.responsable.id);
        const existeAct = aux2.filter(res => res.id === resp.responsable.id);
        if (existeAct.length === 0) {
          aux2.push({
            nombre: resAct[0].nombre,
            name: resAct[0].nombre,
            id: resAct[0].id,
            check: true,
          });
        }
      }
    }
    this.responsablesActas = this.ordenamientoAlf(aux);
    this.selecAllResActas = true;
    this.responsablesActividadesActas = this.ordenamientoAlf(aux2);
    this.selecAllResActiv = true;
  }
  //Mostrar sin considerar responsable
  public mostrar(acta: any) {
    if (this.existeAnio(acta)) {
      return true;
    } else {
      return false;
    }
  }
  //Mostrar considerando los responsables
  public mostrarConResponsables(acta: any) {
    if (this.responsableActas(acta) && this.existeAnio(acta)) {
      return true;
    } else {
      return false;
    }
  }
  //Metodos de decición
  private existeAnio(acta: any) {
    if (acta.fecha_ini !== undefined && acta.fecha_fin !== undefined) {
      var perSelected = this.perSelected();
      var perIni = Meses.getMesesN(moment(acta.fecha_ini).month() + 1) + '-' + moment(acta.fecha_ini).format('YY');
      var perFin = Meses.getMesesN(moment(acta.fecha_fin).month() + 1) + '-' + moment(acta.fecha_fin).format('YY');
      return Meses.compararPer(perIni, perFin, perSelected);
    }
    return false;
  }
  private responsableActas(acta: any) {
    for (const res of this.responsablesActas) {
      if (res.id === acta.responsable.id && res.check) {
        return true;
      }
    }
    return false;
  }
  public responsableActOfActas(act: any) {
    for (const res of this.responsablesActividadesActas) {
      if (res.id === act.responsable.id && res.check) {
        return true;
      }
    }
    return false;
  }
  // Metodos de busqueda
  private perSelected() {
    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.check) {
          return mes.periodo;
        }
      }
    }
    return '';
  }
  /* Funcionamiento de los filtros */
  //Filtro de años
  public cambioAnio(data: any) {
    const per = data.periodo;

    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        mes.periodo === per ? mes.check = true : mes.check = false;
        mes.periodo === per ? this.Periodo = mes.periodo : '';
      }
    }
    this.dataTablaMostrar('cam');
    this.obtResponsableDinamico();
  }
  //Filtro de lider actas
  public cambioLider(pers) {
    if(pers !== 'consolidado'){
      this.responsablesActas.forEach(res =>{ res.nombre === pers.nombre? res.check = !res.check: res.check = res.check});
      var all = 0;
      this.responsablesActas.forEach(res =>{ res.check? all++ : all = all });
      if(all === this.responsablesActas.length){
        this.selecAllResActas = true
      }else{
        this.selecAllResActas = false;
      }
    }else{
      if(this.selecAllResActas){
        this.responsablesActas.forEach(res =>{ res.check = false});
      }else{
        this.responsablesActas.forEach(res =>{ res.check = true});
      }
      this.selecAllResActas = !this.selecAllResActas
      
    }
    if( pers !== undefined || this.selecAllResActas){
      this.dataTablaMostrar('all');
    }
  }
  public selecAllLideres() {
    this.responsablesActas.forEach(res => this.selecAllResActas ? res.check = false : res.check = true);
    this.selecAllResActas = !this.selecAllResActas;
    if (this.selecAllResActas) {
      this.dataTablaMostrar('all');
    }
  }
  //Filtro de responsable actividades
  public cambioResponsable(pers) {
    if(pers != 'consolidado'){
      this.responsablesActividadesActas.forEach(res =>{ res.nombre === pers.nombre? res.check = !res.check: res.check = res.check});
      var all = 0;
      this.responsablesActividadesActas.forEach(res =>{ res.check? all++ : all = all });
      if(all === this.responsablesActividadesActas.length){
        this.selecAllResActiv = true
      }else{
        this.selecAllResActiv = false;
      }
    }else{
      if(this.selecAllResActiv){
        this.responsablesActividadesActas.forEach(res =>{ res.check = false});
      }else{
        this.responsablesActividadesActas.forEach(res =>{ res.check = true});
      }
      this.selecAllResActiv = !this.selecAllResActiv
    }
    if( pers !== undefined || this.selecAllResActiv){
      this.dataTablaMostrar('all');
    }
  }
  public selecAllResponsables() {
    this.responsablesActividadesActas.forEach(res => this.selecAllResActiv ? res.check = false : res.check = true);
    this.selecAllResActiv = !this.selecAllResActiv;
    if (this.selecAllResActiv) {
      this.dataTablaMostrar('all');
    }
  }
  //Vision de los tres puntos
  public tresPuntosVis() {
    var sel = 0;
    for (const res of this.responsablesActas) {
      if (res.check) {
        sel++;
      }
    }
    if (sel <= 1)
      return false;
    return true;
  }
  public tresPuntosVisResp() {
    var sel = 0;
    for (const res of this.responsablesActividadesActas) {
      if (res.check) {
        sel++;
      }
    }
    if (sel <= 1)
      return false;
    return true;
  }
  /** Borrar filtros */
  public borrarFiltro() {
    document.body.style.cursor = 'wait';

    this.Periodo = this.aniosDisponibles[this.aniosDisponibles.length - 1].series[this.aniosDisponibles[this.aniosDisponibles.length - 1].series.length - 1].periodo;
    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.periodo !== this.Periodo) {
          mes.check = false;
        } else {
          mes.check = true;
        }
      }
    }

    this.responsablesActas.forEach(res => res.check = true);
    this.responsablesActividadesActas.forEach(res => res.check = true);

    this.ordenamiento = 'id';

    this.dataTablaMostrar('cam');
    this.obtResponsableDinamico();

    setTimeout(() => {
      document.body.style.cursor = 'default';
    }, 2000);
  }
  /* Eventos de tablas */
  public mostrarTodasLasActas() {
    this.actasMostrar.forEach(acta => this.mostrarAllActas ? acta.check = false : acta.check = true)
    this.mostrarAllActas = !this.mostrarAllActas;
  }
  public mostrarActas(acta: any) {
    acta.check = !acta.check;
    var actasAbiertas = 0;
    for (const actas of this.actasMostrar) {
      if (actas.check) {
        actasAbiertas++;
      }
    }
    if (actasAbiertas === this.actasMostrar.length) {
      this.mostrarAllActas = true;
    } else if (actasAbiertas === 0) {
      this.mostrarAllActas = false;
    }
  }
  public existAct(act: any) {
    var existePeriodo = false;
    var per_sel = this.perSelected();

    if (act.fecha_inicio != undefined && act.fecha_fin != undefined) {
      var per1 = Meses.getMesesN(moment(act.fecha_inicio).month() + 1) + '-' + moment(act.fecha_inicio).format('YY');
      var per2 = Meses.getMesesN(moment(act.fecha_fin).month() + 1) + '-' + moment(act.fecha_fin).format('YY');
      existePeriodo = Meses.compararPer(per1, per2, per_sel);
    }

    return existePeriodo;
  }
  public async abrirArchivo(acta: any) {
    try {
      const response = await firstValueFrom(this.actasService.getFileActas(acta));
      let fileName = acta.acta;
      const extension = fileName.split('.')[fileName.split('.').length - 1];

      switch (extension) {
        case 'pdf':
          const mediaType = 'application/pdf';
          const blob = new Blob([response], { type: mediaType });
          const nav = (window.navigator as any);

          if (nav.msSaveOrOpenBlob) {
            nav.msSaveOrOpenBlob(blob, fileName);
          } else {
            const a = document.createElement('a');
            const url = URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            window.open("" + a.href, "_blank");

            setTimeout(function () {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            }, 0);
          }
          break;
        case 'png':
        case 'jpg':
          const mediaTypei = 'image/' + extension;
          const blobi = new Blob([response], { type: mediaTypei });
          const navi = (window.navigator as any);

          if (navi.msSaveOrOpenBlob) {
            navi.msSaveOrOpenBlob(blobi, fileName);
          } else {
            const a = document.createElement('a');
            const url = URL.createObjectURL(blobi);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            window.open("" + a.href, "_blank");
            a.click();

            setTimeout(function () {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            }, 0);
          }
          break;
        default:
          const mediaTyped = 'aplication/' + extension;
          const blobd = new Blob([response], { type: mediaTyped });
          const navd = (window.navigator as any);

          if (navd.msSaveOrOpenBlob) {
            navd.msSaveOrOpenBlob(blobd, fileName);
          } else {
            const a = document.createElement('a');
            const url = URL.createObjectURL(blobd);
            a.href = url;
            a.download = fileName.split('-')[fileName.split('-').length - 1];
            document.body.appendChild(a);
            a.click();

            setTimeout(function () {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            }, 0);
          }
          break;
      }
    } catch (error) {
      messages.errorMessageGraph(this.translate.instant('gestion.seguimiento.actas.errorAbrirArchivo'));
    }
  }
  public async puedeValidar(responsable: any, actividad: any) {
    if (responsable.email.toLowerCase() === this.dataService.user.toLowerCase() && actividad.completada) {
      var text = '';
      if (actividad.validacion) {
        text = this.translate.instant('gestion.seguimiento.actas.quitarValidacion');
      } else {
        text = this.translate.instant('gestion.seguimiento.actas.validar');
      }

      try {
        const result = await messages.confirmationSave(
          this.translate.instant('¿' + text + '?'),
          this.translate.instant(''),
          this.translate
        );

        if (result) {
          actividad.validacion = !actividad.validacion;
          await firstValueFrom(this.actasService.patchActividades(actividad));
          messages.succesMessageGraph(this.translate.instant('gestion.seguimiento.actas.actividadValidada'));
        }
      } catch (error) {
        messages.errorMessageGraph(error);
      }
    } else {
      var subText = ''
      if (!actividad.completada) {
        subText = this.translate.instant('gestion.seguimiento.actas.actividadNoCompletada');
      }
      Swal.fire({
        title: this.translate.instant('gestion.seguimiento.actas.noValidacion'),
        text: '' + subText,
        icon: 'error',
        showConfirmButton: false,
        timer: this.dataService.time
      });
    }
  }
  /** Metodos de ordenamiento */
  private ordenamientoPer(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  private ordenamientoAdi(array: any) {
    array.sort(function (a: any, b: any) {
      if (a.name > b.name) {
        return 1;
      }
      if (a.name < b.name) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  private ordenamientoAlf(array: any) {
    array.sort(function (a: any, b: any) {
      if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) {
        return 1;
      }
      if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  private ordenamientoAlfInv(array: any) {
    array.sort(function (a: any, b: any) {
      if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) {
        return 1;
      }
      if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  public ordenamientoSem(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.value_00) > Number(b.value_00)) {
        return 1;
      }
      if (Number(a.value_00) < Number(b.value_00)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  private ordenamientoHis(array){
    array.sort(function (a: any, b: any) {
      let af = moment(Meses.escrituraPer(a.periodo), 'MM/DD/YY');
      let bf = moment(Meses.escrituraPer(b.periodo), 'MM/DD/YY');
      if (bf.isBefore(af)) {
        return 1;
      }
      if (af.isBefore(bf)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  public obtenerDias(fIni: any, fFin: any) {
    let dias = 0;
    let inicio = moment(fIni);
    let fin = moment(fFin);
    let diff = fin.diff(inicio, 'days');

    if (diff === 0) {
      diff = 1;
    }

    switch (this.diasLab) {
      case 'Lunes-Viernes':
        let sem = Math.trunc(diff / 7);
        dias = diff - sem * 2;
        break;
      case 'Lunes-Sabado':
        let semSab = Math.trunc(diff / 7);
        dias = diff - semSab;
        break;
      case 'Lunes-Domingo':
        dias = diff;
        break;
    }

    return dias;
  }
  //Escribir datos
  public escribirDat(historico: any, tip: string) {
    var per = this.perSelected();
    if (historico) {
      for (const dat of historico) {
        if (per === dat.periodo) {
          if (tip === 'plan') {
            return dat.planeado;
          } else if (tip === 'ejec') {
            return dat.ejecutado;
          }
        }
      }
    }
  }
  public escribirDatPro(acta: any, tip: string) {
    var per = this.perSelected();
    var dias = 0, porcentajeplan = 0, porcentajeejec = 0;
    for (const act of acta.actividades) {
      dias += this.obtenerDias(act.fecha_inicio, act.fecha_fin);
    }
    var suma = false;
    for (const act of acta.actividades) {
      if (moment(`20${per.split('-')[1]}-${Meses.getMesesS(per.split('-')[0])}-01`).isAfter(moment(act.fecha_fin))) {
        suma = true;
      }
      for (const his of act.history) {
        if (his.periodo === per || suma) {

          if (suma) {
            suma = false;
            var diasAct = this.obtenerDias(act.fecha_inicio, act.fecha_fin);
            var pesoAct = Number((diasAct * 100 / dias).toFixed(2));
            porcentajeplan += Number((100 * pesoAct / 100).toFixed(2));
            let perAct = Meses.obtnerPer(moment(act.fecha_fin).toDate());
            var ejeAct = 0;
            for (const h of act.history) {
              if (h.periodo === perAct) {
                ejeAct = h.ejecutado;
                break;
              }
            }
            porcentajeejec += Number((ejeAct * pesoAct / 100).toFixed(2));
          } else {
            var diasAct = this.obtenerDias(act.fecha_inicio, act.fecha_fin);
            var pesoAct = Number((diasAct * 100 / dias).toFixed(2));
            porcentajeplan += Number((his.planeado * pesoAct / 100).toFixed(2));
            porcentajeejec += Number((his.ejecutado * pesoAct / 100).toFixed(2));
          }
        }
      }
    }
    if (tip === 'plan') {
      if (Number(porcentajeplan.toFixed(2)) >= 99.99) {
        return 100;
      }
      return Number(porcentajeplan.toFixed(2));
    }
    return Number(porcentajeejec.toFixed(2));
  }
  //Bordes
  public pintarBordPro(eje: any, plan: any) {
    if (eje !== 0) {
      var color = '';
      var por = eje * 100 / plan;
      var valfin = 0;
      for (const sem of this.semaforo) {
        if (valfin < sem.valfin) {
          valfin = sem.valfin
        }
      }
      if (por >= valfin) {
        por = valfin - 1;
      }
      for (const sem of this.semaforo) {
        var ab = sem.valIn;
        if (ab !== 0) {
          ab = ab - 0.1;
        }
        if (por >= ab && por <= sem.valfin) {
          color = sem.color;
          break;
        }
      }
      switch (color) {
        case 'verde': return 'bordeVerde';
        case 'azul': return 'bordeAzul';
        case 'amarillo': return 'bordeAmarillo';
        case 'naranja': return 'bordeNaranja';
        case 'rojo': return 'bordeRojo';
        default: return 'bordeGris';
      }
    }
    return 'bordeGris'
  }
  public pintarBord(eje: any, plan: any) {
    var porcentaje = undefined;
    var color = '';
    if (eje === 0 && plan !== 0 && this.dataService.company_name === 'Unión Popular') {//'Raiffeisen Latina' ){//
      return 'bordeNegro';
    } else if (eje === 0 && plan !== 0) {
      porcentaje = 0;
    } else if (eje !== 0 && eje !== null) {
      porcentaje = eje * 100 / plan;

    }
    if (porcentaje !== undefined) {
      var valfin = 0;
      for (const sem of this.semaforo) {
        if (valfin < sem.valfin) {
          valfin = sem.valfin
        }
      }
      if (porcentaje >= valfin) {
        porcentaje = valfin - 1;
      }
      for (const sem of this.semaforo) {
        var ab = sem.valIn;
        if (ab !== 0) {
          ab = ab - 0.1;
        }
        if (porcentaje >= ab && porcentaje <= sem.valfin) {
          color = sem.color;
          break;
        }
      }
      switch (color) {
        case 'verde': return 'bordeVerde';
        case 'azul': return 'bordeAzul';
        case 'amarillo': return 'bordeAmarillo';
        case 'naranja': return 'bordeNaranja';
        case 'rojo': return 'bordeRojo';
        default: return 'bordeGris';
      }
    }
    return 'bordeGris'
  }
  //Escritura de los adicionales
  public escribirAdicionalPro(actividades: any, i: number) {
    var presTot = 0;
    var presTotN = 0;
    for (const act of actividades) {
      if (act.adicionales[i] !== null && act.adicionales[i].type === 'moneda') {
        presTot += act.adicionales[i].amount;
      }
    }
    if (actividades[0].adicionales[i].type === 'moneda') {
      return this.formatearnormal(presTot);
    } else {
      return '';
    }
  }
  private obtCommentNumero(com: any) {
    for (const comen of com) {
      var per = 0;
      for (const an of this.aniosDisponibles) {
        for (const mes of an.series) {
          if (mes.check) {
            per = an.anio;
          }
        }
      }
      var percom = moment(comen.createdAt).year();
      if (per === percom) {
        return comen.comment;
      }
    }
    return '';
  }
  private obtComment(com: any) {
    for (const comen of com) {
      var per = this.perSelected();
      var percom = Meses.obtnerPer(moment(comen.createdAt).toDate());
      if (per === percom) {
        return comen.comment;
      }
    }
    return '';
  }
  // Abrir adicionales
  public async abirPDF(ad, event?: any) {
    const per = this.perSelected();
    for (const fil of ad.files) {
      if (Meses.obtnerPer(moment(fil.createdAt).toDate()) === per) {

        try {
          const response = await firstValueFrom(this.actasService.getFile(ad.id, fil.id));
          const extension = fil.name.split('.')[fil.name.split('.').length - 1];

          switch (extension) {
            case 'pdf':
              const mediaType = 'application/pdf';
              const blob = new Blob([response], { type: mediaType });
              const nav = (window.navigator as any);

              if (nav.msSaveOrOpenBlob) {
                nav.msSaveOrOpenBlob(blob, fil.name);
              } else {
                const a = document.createElement('a');
                const url = URL.createObjectURL(blob);
                a.href = url;
                a.download = fil.name;
                document.body.appendChild(a);
                window.open("" + a.href, "_blank");

                setTimeout(function () {
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);
                }, 0);
              }
              break;
            case 'png':
            case 'jpg':
              const mediaTypei = 'image/' + fil.name.split('.')[fil.name.split('.').length - 1];
              const blobi = new Blob([response], { type: mediaTypei });
              const navi = (window.navigator as any);

              if (navi.msSaveOrOpenBlob) {
                navi.msSaveOrOpenBlob(blobi, fil.name);
              } else {
                const a = document.createElement('a');
                const url = URL.createObjectURL(blobi);
                a.href = url;
                a.download = fil.name;
                document.body.appendChild(a);
                window.open("" + a.href, "_blank");
                a.click();

                setTimeout(function () {
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);
                }, 0);
              }
              break;
            default:
              const mediaTyped = 'aplication/' + fil.name.split('.')[fil.name.split('.').length - 1];
              const blobd = new Blob([response], { type: mediaTyped });
              const navd = (window.navigator as any);

              if (navd.msSaveOrOpenBlob) {
                navd.msSaveOrOpenBlob(blobd, fil.name);
              } else {
                const a = document.createElement('a');
                const url = URL.createObjectURL(blobd);
                a.href = url;
                a.download = fil.name.split('-')[fil.name.split('-').length - 1];
                document.body.appendChild(a);
                a.click();

                setTimeout(function () {
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);
                }, 0);
              }
              break;
          }
        } catch (error) {
          messages.errorMessageGraph(error);
        }
      }
    }
  }
  public editar(his: any, idAct: any) {
    var perSel = '';
    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.check) {
          perSel = mes.periodo;
        }
      }
    }
    var perAct = Meses.obtnerPer(this.fechaAct.toDate());
    var perAnt = Meses.obtnerPerAnt(this.fechaAct.toDate());
    if (this.edicion) {
      this.dat(his, perSel, idAct);
      return;
    } else if (Meses.compararPer(perAnt, perAct, perSel)) {
      this.dat(his, perSel, idAct)
    } else {
      Swal.fire({
        title: this.translate.instant('gestion.seguimiento.actas.periodoNoEditable'),
        text: this.translate.instant('gestion.seguimiento.actas.periodoNoEditableText'),
        confirmButtonColor: '#ff6b00',
        cancelButtonColor: '#B9B9BC',
        confirmButtonText: this.translate.instant('swal.acep'),
        cancelButtonText: this.translate.instant('swal.cerr'),
      });
    }

  }
  public async dat(his: any, perSel: any, idAct: any) {
    var inputValue = 0, introdujo: any, guardo = false;

    for (const per of his) {
      if (per.periodo === perSel) {
        inputValue = per.ejecutado;
      }
    }

    introdujo = await Swal.fire({
      title: this.translate.instant('gestion.seguimiento.actas.ingreseDato'),
      text: "",
      input: 'number',
      inputValue: inputValue,
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (Number(value) > 100) {
          return this.translate.instant('gestion.seguimiento.actas.valorNoValido');
        }
        guardo = true;
        return '';
      }
    });

    if (guardo) {
      const reg = his.find(h => h.periodo === perSel);
        if(reg.id !== 0 && introdujo.value !== ''){
          for(const per of his){
            if(per.periodo === perSel){
              if(introdujo.value !== ''){
                per.ejecutado = Number(introdujo.value);
              }else{
                per.ejecutado = null;
              }
              const res = await firstValueFrom(this.actaService.PatchHistorico(per, Number(per.id))); 
              messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
            }
          }
        }else if(reg.id === 0 && introdujo.value !== ''){
          reg.ejecutado = Number(introdujo.value);
          const res = await firstValueFrom(this.actaService.postHistorico(reg, Number(idAct))); 
          reg.id = res.id;
          messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
        }else if(reg.id !== 0 && introdujo.value === ''){
          try{
            await firstValueFrom(this.actaService.deleteHistorico(reg));
            messages.succesMessageGraph(this.translate.instant('swal.swalElimino'));
            reg.id = 0;
            reg.ejecutado = null;
          }catch(err){
            messages.errorMessageGraph(err);
          }
        }
    }
  }

  public async edicionAd(adic: any, id: any, event?: any) {
    var inputValue: any, introdujo: any, guardo = false;

    switch (adic.type) {
      case 'texto':
        inputValue = this.obtComment(adic.comments);
        introdujo = await Swal.fire({
          title: this.translate.instant('gestion.seguimiento.actas.ingreseComentario'),
          text: "",
          input: 'text',
          inputValue: inputValue,
          showCancelButton: true,
          confirmButtonColor: '#ff6b00',
          cancelButtonColor: '#B9B9BC',
          confirmButtonText: this.translate.instant('swal.acep'),
          cancelButtonText: this.translate.instant('swal.cerr'),
          reverseButtons: true,
          customClass: {
            actions: 'aleema-swal-actions',
            confirmButton: 'aleema-swal-confirm',
            cancelButton: 'aleema-swal-cancel',
            input: 'aleema-swal-select'
          },
          inputValidator: (value) => {
            guardo = true;
            return '';
          }
        });
        break;
      case 'moneda':
        inputValue = adic.amount;
        introdujo = await Swal.fire({
          title: this.translate.instant('gestion.seguimiento.actas.ingreseMonto'),
          text: "",
          input: 'number',
          inputValue: inputValue,
          showCancelButton: true,
          confirmButtonColor: '#ff6b00',
          cancelButtonColor: '#B9B9BC',
          confirmButtonText: this.translate.instant('swal.acep'),
          cancelButtonText: this.translate.instant('swal.cerr'),
          reverseButtons: true,
          customClass: {
            actions: 'aleema-swal-actions',
            confirmButton: 'aleema-swal-confirm',
            cancelButton: 'aleema-swal-cancel',
            input: 'aleema-swal-select'
          },
          inputValidator: (value) => {
            if (!value) {
              return this.translate.instant('gestion.seguimiento.actas.ingreseDatoValido');
            }
            guardo = true;
            return '';
          }
        });
        break;
      case 'archivo':
        inputValue = adic.file;
        introdujo = await Swal.fire({
          title: this.translate.instant('gestion.seguimiento.actas.seleccioneArchivo'),
          text: "",
          input: 'file',
          inputValue: inputValue,
          showCancelButton: true,
          confirmButtonColor: '#ff6b00',
          cancelButtonColor: '#B9B9BC',
          confirmButtonText: this.translate.instant('swal.acep'),
          cancelButtonText: this.translate.instant('swal.cerr'),
          reverseButtons: true,
          customClass: {
            actions: 'aleema-swal-actions',
            confirmButton: 'aleema-swal-confirm',
            cancelButton: 'aleema-swal-cancel',
            input: 'aleema-swal-select'
          },
          inputValidator: (value) => {
            if (!value) {
              return this.translate.instant('gestion.seguimiento.actas.ingreseDatoValido');
            }
            guardo = true;
            return '';
          }
        });
        break;
    }

    if (guardo) {
      switch (adic.type) {
        case 'texto':
          var existe = false;
          var per =  this.perSelected();
          for(const comen of adic.comments){
            var percom = Meses.obtnerPer(new Date(comen.createdAt));
            if(per === percom){
              comen.comment = introdujo.value==''?' ':introdujo.value;
              existe = true;
              const res = await firstValueFrom(this.actaService.patchComment(comen, adic.id));
              messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
            }
          }
          if(!existe){
            var date = (new Date(Meses.getMesesS(per.split('-')[0])+'-1-'+per.split('-')[1]));
            adic.comments.push({
              comment: introdujo.value,
              createdAt: date.toISOString(),
            });
            var aux = {
              comment: introdujo.value,
              createdAt: date.toISOString()
            }
            const res = await firstValueFrom(this.actaService.postComment(aux, adic.id)); 
            messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
          }
          break;
        case 'moneda':
          adic.amount = introdujo.value;
          break;
        case 'archivo':
          this.progressInfo = [];
          introdujo.value ? this.imageName = introdujo.value.name : this.imageName = introdujo.value.length + " archivos";
          this.selectedFiles = introdujo.value;
          var per  = this.perSelected();
          var existe = false;
          if( this.selectedFiles["size"] > obtenerTamMax.getPeso() ){
            messages.errorMessageGraph(obtenerTamMax.getTexto());
            this.edicionAd(adic, id, event);
          }else{
              messages.messageSaving(this.translate.instant('swal.agregandoInfo'),this.translate.instant('swal.espere'))
              var date = (new Date(Meses.getMesesS(per.split('-')[0])+'-1-'+per.split('-')[1]));
              const res = await firstValueFrom(this.actaService.postFile(this.selectedFiles, adic.id, date.toISOString()));
              let aux = {
                id: res.id,
                name: res.name,
                description: res.description,
                path: res.path,
                createdAt: date.toISOString()
              }
              const pr = this.actas.find(p => p.actividades.find(a => a.id === id));
              const ac = pr.actividades.find(a => a.id === id);
              const adG = ac.adicionales.find(a => a.id === adic.id);
              adG.files.push({ ...aux});
              messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
          }
          break;
      }
    } else {
      messages.errorMessageGraph(this.translate.instant('swal.cancelado'));
    }
  }
  //eliminar archivos
  public async deleteArchivo() {
    const per = this.perSelected();

    try {
      const result = await messages.confirmationSave(
        this.translate.instant('gestion.seguimiento.actas.eliminarArchivo'),
        this.translate.instant(''),
        this.translate
      );

      if (result) {
        document.getElementById('cargando_arch')['style'].display = 'block';

        for (const fil of this.adDelete.files) {
          if (Meses.obtnerPer(moment(fil.createdAt).toDate()) === per) {
            try {
              const res = await firstValueFrom(this.actaService.deleteFile(this.adDelete.id, fil.id));
              const pr = this.actas.find(p => p.actividades.find(a => a.id === this.adActivi.id));
              const ac = pr.actividades.find(a => a.id === this.adActivi.id);
              const adG = ac.adicionales.find(a => a.id === this.adDelete.id);
              adG.files = adG.files.filter(f => f.id !== fil.id); 
              messages.succesMessageGraph(this.translate.instant('swal.swalElimino'));
            } catch (err) {
              let er = obtenerError.errorObt(err['error']?.message);
              messages.errorMessageGraph(er);
            }
          }
        }

        document.getElementById('cargando_arch')['style'].display = 'none';
      }
    } catch (error) {
      document.getElementById('cargando_arch')['style'].display = 'none';
      messages.errorMessageGraph(error);
    }
  }
  // Menu click izquierdo
  public onContextMenu(event: MouseEvent, item, activitie) {
    event.preventDefault(); 
    // we record the mouse position in our object 
    this.menuTopLeftPosition.x = event.clientX + 'px'; 
    this.menuTopLeftPosition.y = event.clientY + 'px'; 

    this.adDelete = item;
    this.adActivi = activitie;
    this.matMenuTrigger.openMenu();
  }
  public escribirAdicional(adic: any) {
    if (adic != undefined) {
      switch (adic.type) {
        case 'texto':
          return this.obtComment(adic.comments);
        case 'moneda':
          return this.formatearnormal(adic.amount);
        case 'numero':
          return this.obtCommentNumero(adic.comments);
        case 'archivo':
          var per = this.perSelected();
          for (const file of adic.files) {
            if (per === Meses.obtnerPer(moment(file.createdAt).toDate())) {
              return file.name.split('-')[file.name.split('-').length - 1];
            }
          }
          return '';
      }
    }
  }
  /** Formato de cantidades */
  public formatearnormal(num: any) {
    if (num === null) {
      return 0;
    }
    num += '';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
    }
    return splitLeft;
  }
  /** Ordenamiento */
  public ordenamientoTabla() {
    switch (this.ordenamiento) {
      case 'id':
        this.actasMostrar = this.ordenamientoAlf(this.actasMostrar);
        this.ordenamiento = 'asc';
        break;
      case 'asc':
        this.actasMostrar = this.ordenamientoAlfInv(this.actasMostrar);
        this.ordenamiento = 'des';
        break;
      case 'des':
        this.actasMostrar = this.ordenamientoPer(this.actasMostrar);
        this.ordenamiento = 'id';
        break;
    }
  }
  /* Exportación a excel */
  public exportarExcel() {
    var title = this.translate.instant('titExcel') + this.Periodo;
    var header = ["Actas / Actividades", "Inicio", "Fin", "Líder", "Planeado", "Ejecutado", "Validación"];
    if (this.actasMostrar[0].actividades[0].adicionales.length !== 0) {
      for (var j = 0; j < this.actasMostrar[0].actividades[0].adicionales.length; j++) {
        header.push("" + this.actasMostrar[0].actividades[0].adicionales[j].name);
      }
    }

    var data = [];
    var aux = [];
    for (const acta of this.actasMostrar) {
      aux.push(acta.nombre);
      var fecha = this.obtFecha(acta.fecha_ini);
      aux.push(fecha.split('-')[0] + '/' + fecha.split('-')[1] + '/20' + fecha.split('-')[2]);
      fecha = this.obtFecha(acta.fecha_fin);
      aux.push(fecha.split('-')[0] + '/' + fecha.split('-')[1] + '/20' + fecha.split('-')[2]);
      aux.push(acta.responsable.position);
      aux.push(this.escribirDatPro(acta, 'plan'));
      aux.push(this.escribirDatPro(acta, 'ejec') === null ? 'null' : this.escribirDatPro(acta, 'ejec'));
      aux.push(' ')
      if (acta.actividades[0].adicionales.length !== 0) {
        for (var j = 0; j < acta.actividades[0].adicionales.length; j++) {
          aux.push(this.escribirAdicionalPro(acta.actividades, j));
        }
      }
      data.push(aux);
      aux = [];
      for (const acti of acta.actividades) {
        aux.push('-' + acti.nombre)
        var fecha = this.obtFecha(acti.fecha_inicio);
        aux.push(fecha.split('-')[0] + '/' + fecha.split('-')[1] + '/20' + fecha.split('-')[2]);
        fecha = this.obtFecha(acti.fecha_fin);
        aux.push(fecha.split('-')[0] + '/' + fecha.split('-')[1] + '/20' + fecha.split('-')[2]);
        aux.push(acti.responsable.position);
        aux.push(this.escribirDat(acti.history, 'plan'));
        aux.push(this.escribirDat(acti.history, 'ejec') === null ? 'null' : this.escribirDat(acti.history, 'ejec'));
        aux.push(this.escribirDat(acti.history, 'plan') === 100 ? '' + acti.validacion : '')
        if (acti.adicionales.length !== 0) {
          for (const ad of acti.adicionales) {
            aux.push(this.escribirAdicional(ad));
          }
        }
        data.push(aux);
        aux = [];
      }
    }
    const NomArch = this.translate.instant('gestion.seguimiento.actas.nombreExcel')
    this.excelService.generateExcelActas(title, header, data, NomArch, this.semaforo);
  }
}
